/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import "../css/settings.css";

import "../css/instruction.css";
import { Card } from "@shopify/polaris";

class Documment extends React.Component {
  render() {
    return (
      <div style={{ marginTop: "40px" }}>
        <Card>
          <div className="pd-details" style={{ padding: "30px" }}>
            <div className="feature-ct">
              <h4>Why use SyncTrack - Add tracking auto</h4>
              <p>
                Adding tracking info to PayPal improves cash-flow and reduce
                chargebacks, disputes and refund from customers for these
                reasons:
              </p>
              <ol>
                <li>
                  When a red flag is raised regarding your account, PayPal may
                  apply a reserve on it. By adding tracking info, you can
                  improve your account's track record - and have the reserve
                  level lowered (or even completely removed).
                </li>
                <li>
                  When there’s a rocket in sales or disputes or chargebacks
                  level, PayPal is holding your payments for up to 21 days in
                  order to protect the buyers. By adding tracking info, you can
                  access your funds right after delivery with supported
                  carriers.
                </li>
                <li>
                  PayPal's Seller Protection reduces claims and chargebacks and
                  helps prevent fraud. by providing tracking information through
                  PayPal, customers can keep track of their transactions. Also,
                  it is one of the requirements and protects you from disputes
                  like Unauthorized Transaction or Item Not Received.
                </li>
              </ol>
              <h4>Highlight features</h4>
              <ul>
                <li>
                  <p>
                    <span>
                      Safe and easy setup by creating a dedicated PayPal
                      sub-account
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span>
                      Connect to multi Paypal accounts to save your cost
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span>
                      &nbsp;A quick and easy way to activating tracking info
                      submission to Paypal&nbsp;
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span>Real-time access to submission status</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span>
                      Always update reports of fulfilled orders and tracking
                      info submitted on the last 30 days/today/this month/last
                      month/all time
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span>Auto add tracking info to Paypal</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span>
                      Sync tracking numbers from old orders to Paypal (available
                      from basic plan)&nbsp;
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span>Access funds more quickly</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span />
                    <span />
                    <span>Paypal’s seller protection&nbsp;</span>
                  </p>
                </li>
              </ul>
              <p style={{ textAlign: "justify" }}>
                <span>&nbsp;</span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>A</span>
                <span>PP CONFIGURE TUTORIAL</span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>————————————————————————————————</span>
              </p>
              <ul style={{ textAlign: "justify" }}>
                <li>
                  <span> Created: Nov 2019</span>
                </li>
                <li>
                  <span> By:</span>
                  <a href="https://www.omegatheme.com/">
                    {" "}
                    <span>https://www.omegatheme.com/</span>
                  </a>
                </li>
                <li>
                  <span> Email: </span>
                  <a href="mailto:contact@omegatheme.com">
                    <span>contact@omegatheme.com&nbsp;</span>
                  </a>
                </li>
              </ul>
              <p style={{ textAlign: "justify" }}>&nbsp;</p>
              <p style={{ textAlign: "justify" }}>
                <i>
                  <span>
                    This is documentation on the{" "}
                    <strong>SyncTrack - Add tracking auto</strong>
                  </span>
                </i>
                <i>
                  <span>
                    &nbsp;application, which will help you to configure your app
                    in the right way.
                  </span>
                </i>
              </p>
              <p style={{ textAlign: "justify" }}>
                <b>
                  Having tracking info submitted to PayPal - in 3 easy steps
                </b>
              </p>
              <h3 className="mt-3" style={{ textAlign: "justify" }}>
                <b>
                  <span role="img" aria-label="omegatheme">
                    ⭐️
                  </span>{" "}
                  Account Setup
                </b>
                <span>&nbsp;</span>
              </h3>
              <p style={{ textAlign: "justify" }}>
                <span>
                  Install the app on Shopify and connect the app with your
                  PayPal account&nbsp;to let the app sync&nbsp;tracking info to
                  Paypal.
                </span>
              </p>
              <h4 style={{ textAlign: "justify" }}>
                <b>
                  Tutorial on how to create a new user for your Paypal merchant
                  account:
                </b>
              </h4>
              <p style={{ textAlign: "justify" }}>
                <b>Step 1:&nbsp;</b>Add
                <em>
                  <strong> SyncTrack - Add tracking auto</strong>
                </em>{" "}
                app to your app store.&nbsp;
              </p>
              <p style={{ textAlign: "justify" }}>
                <b>Step 2</b>
                <span>
                  : Install the app to your store, then the app will take you to
                  the app admin&nbsp;
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>On Paypal&nbsp;</span>Credentials
                <span>&nbsp;tab, Click </span>
                <strong>
                  <span>Connect with Paypal</span>
                </strong>
                <span>.</span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>
                  <img
                    src="https://www.omegatheme.com/images/1.jpg"
                    alt="connect-app-with-paypal-account"
                  />
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <b>Step 3</b>
                <span>:&nbsp;Login your Paypal account&nbsp;</span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>
                  <img
                    src="https://www.omegatheme.com/images/2.jpg"
                    alt="log-in-paypal-account"
                  />
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <b>Step 4:</b>
                <span>
                  &nbsp;Agree and connect your account with&nbsp;SyncTrack - Add
                  tracking auto app&nbsp;
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>
                  <img
                    src="https://www.omegatheme.com/images/3.jpg"
                    alt="connect-paypal-with-app"
                  />
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <b>Step 5</b>
                <span>
                  : After connecting, it will take back you to the app admin,
                  where you can see the "confirmed" status and credentials ID.
                  Then, the app is ready to&nbsp;adding tracking information to
                  PayPal once the orders are fulfilled.&nbsp;
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>&nbsp;</p>
              <p style={{ textAlign: "justify" }}>
                <img
                  src="https://www.omegatheme.com/images/4.jpg"
                  alt="app-confirmed"
                />
              </p>
              <p style={{ textAlign: "justify" }}>
                <i>
                  <span>
                    <span role="img" aria-label="omegatheme">
                      ✏️
                    </span>
                    Watch the tutorial video to have a better visualization on
                    how to create a limited-access user on PayPal:
                  </span>
                </i>
              </p>
              <p style={{ textAlign: "justify" }}>
                <em>
                  <a
                    href="https://www.youtube.com/watch?v=939S7HqgJi4&feature=youtu.be"
                    rel="alternate"
                  >
                    https://www.youtube.com/watch?v=939S7HqgJi4&amp;feature=youtu.be
                  </a>
                </em>
              </p>
              <p style={{ textAlign: "justify" }}>&nbsp;</p>
              <h3 style={{ textAlign: "justify" }}>
                <b>
                  <span role="img" aria-label="omegatheme">
                    ⭐️
                  </span>{" "}
                  Automatic Notification
                </b>
                <span>&nbsp;</span>
              </h3>
              <p style={{ textAlign: "justify" }}>
                <span>
                  Every time an order is fulfilled and tracking info is added to
                  Shopify, your store notifies us instantly and automatically by
                  Shopify. It will give the order a tracking number and tracking
                  company. We will submit these two to PayPal. This tracking
                  number corresponds to each shipping unit.&nbsp;
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                &nbsp;
                <img
                  src="https://www.omegatheme.com/images/shopify-app/add-paypal-tracking/add-paypal-admin-dashboard.png"
                  alt="Synctrack ‑ Add Tracking Info"
                  width={1140}
                  height={641}
                />
              </p>
              <p style={{ textAlign: "justify" }}>
                <b>Real-time access to submission status:&nbsp;</b>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>
                  SyncTrack - Add tracking auto provides you a piece of fully
                  transparent information available of fulfilled orders and
                  tracking info submitted to PayPal.
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>
                  The data report is constantly updated to keep customers
                  informed about their transactions.
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>
                  You can review the tracking information for Last 30 days /
                  Today / This month / Last month/ All time.
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>&nbsp;</p>
              <h3 style={{ textAlign: "justify" }}>
                <b>
                  <span role="img" aria-label="omegatheme">
                    ⭐️
                  </span>{" "}
                  PayPal Account Status
                </b>
              </h3>
              <h4 style={{ textAlign: "justify" }}>
                <b>Plan Package</b>
              </h4>
              <p style={{ textAlign: "justify" }}>
                <span>
                  In the<strong> Dashboard</strong> tab, you can see the current
                  plan you are using and how many orders have been synced on
                  current month per your package.&nbsp;
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <img
                  src="https://www.omegatheme.com/images/BLOG-KAY/pricing-table.png"
                  alt="pricing-table"
                />
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>Choose a plan that fit with your needs.&nbsp;</span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>
                  Except for the <b>UNLIMITED </b>plan, the other three have a
                  limited number of orders available for submitted to PayPal.
                  For each plan, we submit tracking information to PayPal for
                  one order.&nbsp;
                </span>
              </p>
              <p style={{ textAlign: "justify" }}>
                <span>The plan will be renewed every 30 days.</span>
              </p>
              <p style={{ textAlign: "justify" }}>&nbsp;</p>
              <h4 style={{ textAlign: "justify" }}>
                <span>
                  <b>Paypal Credentials</b>
                </span>
              </h4>
              <h4 style={{ textAlign: "justify" }}>
                &nbsp;
                <img
                  src="https://www.omegatheme.com/images/BLOG-KAY/credentials.png"
                  alt="credentials paypal"
                />
              </h4>
              <p>
                <span>
                  The PayPal Credentials you created allows us to access your
                  PayPal account.
                </span>
              </p>
              <p>
                <span>
                  The Client ID &amp; Secret provide us the minimal permissions
                  to access your account in order to add tracking code to
                  PayPal.
                </span>
              </p>
              <p>
                <span>
                  It is possible to change the credentials information by
                  clicking on<span>&nbsp;</span>
                </span>
                <b>Modify</b>
                <span>&nbsp;</span>
                <b>Credentials.</b>
              </p>
              <p>
                <b>
                  <i>
                    <span>
                      <span role="img" aria-label="omegatheme">
                        ✏️
                      </span>{" "}
                      &nbsp; &nbsp;NOTES:&nbsp;
                    </span>
                  </i>
                </b>
              </p>
              <ul>
                <li>
                  <b>
                    <i>
                      <span>Get old orders </span>
                    </i>
                  </b>
                  <i>
                    function allows you to sync tracking numbers from old orders
                    to Paypal, you need to grant the app access to use
                    this.&nbsp;
                  </i>
                </li>
                <li>
                  <i>
                    <strong>Upload CSV function </strong>lets you
                    <strong>&nbsp;</strong>upload orders from other platforms
                    with a template file. The app will automatically detect the
                    info and helps you add tracking numbers to Paypal.&nbsp;
                    <br />
                  </i>
                </li>
              </ul>
              <p>&nbsp;</p>
              <h4 style={{ textAlign: "justify" }}>
                <b>
                  <i>
                    If you have any problem in using SyncTrack - Add tracking
                    auto please do not hesitate to contact us at{" "}
                  </i>
                </b>
                <span>contact@omegatheme.com</span>
                <b>
                  <i>
                    , our support team will make sure your problem is solved as
                    soon as possible.&nbsp;
                  </i>
                </b>
              </h4>
              <h4>
                *** Don't have a Shopify store already?<span> </span>
                <a
                  rel="noopener noreferrer"
                  href="https://www.shopify.com/?ref=omegaapps"
                  target="_blank"
                >
                  Start your free 14-day trial here!
                </a>
              </h4>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default Documment;
